// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: "AIzaSyAFL2PTRjfyNrV9vzM4_q50ikY-P1fxarg",
  authDomain: "stylgame-configurator.firebaseapp.com",
  projectId: "stylgame-configurator",
  storageBucket: "stylgame-configurator.firebasestorage.app",
  messagingSenderId: "569159253132",
  appId: "1:569159253132:web:fb7208cc496a105aa54fa9"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app); 
const db = getFirestore(app);
export const storage = getStorage(app)

export { db };
